import React, { useEffect } from 'react';
import Grid from '@mui/material/Grid';
import { withRouter } from "react-router";
import { connect } from 'react-redux';
import {
  goToPushRedirect,
  dismissNotification,
  refreshNotifications,
  getNotifications
} from '../../actions';
import ObiLoadingFlat from './ObiLoadingFlat';
import { Button, Typography, IconButton, Tooltip } from '@mui/material';
import NotificationItem from './NotificationItem';

import RefreshIcon from '@mui/icons-material/Refresh';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';

import ObiActionTitle from './ObiActionTitle';

function NotificationListing({type, ...props}){

  useEffect(() => {
    props.getNotifications(props.token, props.user.ID, type, 0);
  }, []);

  const handlePressNotification = (e, onPress) => {
    e.preventDefault();
    props.goToPushRedirect(null, onPress)
  };

  const handleDissmissNotification = (notification_index) => {
    props.dismissNotification(props.token, props.user.ID, type, notification_index)
  }

  const handlePressLoadMore = () => {
    const requestStart = Object.entries(props.notifications).length + 1;
    props.getNotifications(props.token, props.user.ID, type, requestStart);
  }

  const handlePressRefresh = () => {
    props.refreshNotifications(props.token, props.user.ID, type)
  }

  const renderNotificationItem = (entry) => {
    const index = entry[0];
    const notificationKey = 'Notif_'+index;
    const value = entry[1];
    return <NotificationItem 
      key={notificationKey} 
      data={value}
      onDismiss={() => handleDissmissNotification(index)} 
      onClick={(value.data && value.data.webOnPress)? (e) => handlePressNotification(e, value.data.webOnPress) : false} 
      />;
  }

  const renderNotificationList = () => {
    const arrayNotifications = Object.entries(props.notifications);
    
    return arrayNotifications.map((entry) => renderNotificationItem(entry));
  }

  return (
    <Grid container justifyContent="center" spacing={3}>
      <Grid item xs={12}>
        <Grid container direction="row" justifyContent="flex-start" alignItems={'center'} spacing={1}>
          {(props.backAction) && <Grid item><IconButton size="small" onClick={()=>props.backAction()}><ArrowBackIosIcon fontSize="small" style={{paddingLeft: '5px'}}/></IconButton></Grid>}
          <Grid item xs>
          <ObiActionTitle title="Notifications">
            <Tooltip title="Refresh" arrow aria-label="Refresh"><IconButton size="small" color="primary" onClick={handlePressRefresh}><RefreshIcon /></IconButton></Tooltip>
          </ObiActionTitle>
          </Grid>
        </Grid>
      </Grid>
      {(props.notifications && Object.keys(props.notifications).length > 0)?
        renderNotificationList()
       :
        <Grid item xs={12}><Typography variant="body1" align="center" color="grey">No notifications</Typography></Grid>}
      {(props.loading)? <ObiLoadingFlat />:  <Button fullWidth={true} color="primary" disabled={props.loading} onClick={handlePressLoadMore}>Load More</Button>}
    </Grid>
  );
}

const mapStateToProps = (state) => {
  return {
    user: state.auth.user,
    token: state.auth.token,
    notifications: state.general.notifications,
    error: state.general.error,
    errors: state.general.errors,
    loading: state.general.loading,
  };
};

export default connect(mapStateToProps, {
  goToPushRedirect,
  dismissNotification,
  refreshNotifications,
  getNotifications
})(withRouter(NotificationListing));
